import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.sort";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.array.filter";
import React, { createContext } from 'react';
import ReactDOM from 'react-dom';
import { useTransition, animated } from 'react-spring';
var DarkModeContext = createContext(false);

function Notification(_a) {
  var message = _a.message,
      _b = _a.kind,
      kind = _b === void 0 ? 'info' : _b;
  var darkMode = React.useContext(DarkModeContext);
  var classNames = ['ztc-notification', kind, darkMode && 'dark'].filter(Boolean).join(' ');
  return React.createElement("div", {
    className: classNames
  }, React.createElement("span", {
    className: "ztc-message"
  }, message));
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

/* global Reflect, Promise */


var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return _extendStatics(d, b);
};

function __extends(d, b) {
  _extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

var config = {
  height: 64,
  offset: 16,
  component: Notification
};
var MAX_NOTIFICATIONS = 3;
var SCALE_STEP = 0.05;
var TRANSLATE_STEP = 10;

var getUpdateTransforms = function getUpdateTransforms(index, height) {
  var scaleFactor = SCALE_STEP * index;
  var translateFactor = TRANSLATE_STEP * index;
  return {
    translate: "translate(0, -" + (height + translateFactor) + "px)",
    scale: "scale(" + (1 - scaleFactor) + ")"
  };
};

var getOverviewTransforms = function getOverviewTransforms(index, height) {
  var translateFactor = (TRANSLATE_STEP + height) * index;
  return {
    translate: "translate(0, -" + (height + translateFactor) + "px)",
    scale: "scale(1)"
  };
};

var comparator = function comparator(a, b) {
  return b.item.index - a.item.index;
};

var useClickOutside = function useClickOutside(listener) {
  var callback = React.useCallback(listener, []);
  React.useEffect(function () {
    document.addEventListener('click', callback);
    return function () {
      document.removeEventListener('click', callback);
    };
  }, []);
};

var AnimatedContainer = function AnimatedContainer(props) {
  var height = props.height,
      offset = props.offset,
      items = props.notifications,
      Notification = props.component,
      isOverviewing = props.isOverviewing,
      onOverviewToogle = props.onOverviewToogle;
  useClickOutside(function () {
    if (isOverviewing) {
      onOverviewToogle(false);
    }
  });

  var updateTransition = function updateTransition(item) {
    var transforms = isOverviewing ? getOverviewTransforms(item.index, height) : getUpdateTransforms(item.index, height);
    return {
      transform: transforms.translate + " " + transforms.scale,
      opacity: item.index < MAX_NOTIFICATIONS ? 1 : 0
    };
  };

  var transitions = useTransition(items, function (item) {
    return item.key;
  }, {
    update: updateTransition,
    onDestroyed: function onDestroyed() {
      return onOverviewToogle(false);
    },
    from: {
      transform: "translate(0, " + (height + offset) + "px) scale(1)",
      opacity: 0
    },
    enter: {
      transform: "translate(0, -" + height + "px) scale(1)",
      opacity: 1
    },
    leave: {
      opacity: 0
    }
  });

  var renderTransition = function renderTransition(transition) {
    var key = transition.key,
        style = transition.props,
        notification = transition.item;
    return React.createElement(animated.div, {
      key: key,
      style: _assign({
        height: height,
        position: 'absolute',
        width: '100%'
      }, style),
      onMouseEnter: function onMouseEnter() {
        return onOverviewToogle(true);
      },
      onMouseLeave: function onMouseLeave() {
        return onOverviewToogle(false);
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
        onOverviewToogle(true);
      }
    }, React.createElement(Notification, _assign({}, notification)));
  };

  return React.createElement(React.Fragment, null, transitions.sort(comparator).map(renderTransition));
};
/**
 * Keeps the index property of the items in the inversed order, also it
 * has a static capacity which is required by default.
 *
 * [{ index: n - 1 }, { index: n - 2 }, ..., { index: 0 }]
 */


var InverseIndexedQueue =
/** @class */
function () {
  function InverseIndexedQueue(capacity, items) {
    if (items === void 0) {
      items = [];
    }

    this.capacity = capacity;
    this.items = items;
  }

  Object.defineProperty(InverseIndexedQueue.prototype, "length", {
    get: function get() {
      return this.items.length;
    },
    enumerable: true,
    configurable: true
  });

  InverseIndexedQueue.prototype.add = function (newItem) {
    if (this.items.length + 1 > this.capacity) {
      this.items.shift();
    }

    this.items.forEach(function (item) {
      // eslint-disable-next-line no-param-reassign
      item.index += 1;
    });
    this.items.push(newItem);
  };

  InverseIndexedQueue.prototype.pop = function () {
    this.items.shift();
  };

  InverseIndexedQueue.prototype.clone = function () {
    return new InverseIndexedQueue(this.capacity, this.items);
  };

  return InverseIndexedQueue;
}();
/**
 * An small abstraction over `setTimeout`
 */


var Timer =
/** @class */
function () {
  function Timer() {}
  /**
   * Set a timeout-function and clear a previous one created
   * by the timer instance
   *
   * @param callback - timeout-function to be invoked in the future
   * @param timeout - milliseconds
   */


  Timer.prototype.init = function (callback, timeout) {
    clearTimeout(this.id);
    this.id = setTimeout(callback, timeout);
  };
  /**
   * Cancel the timeout-function at any time
   */


  Timer.prototype.cancel = function () {
    clearTimeout(this.id);
  };

  return Timer;
}();

var COLLAPSE_INTERVAL = 300;
var TIMEOUT = 3000;

var NotificationManager =
/** @class */
function (_super) {
  __extends(NotificationManager, _super);

  function NotificationManager() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.countNotifications = 0;
    _this.cleanUpTimer = new Timer();
    _this.dominoTimer = new Timer();
    _this.state = _this.getInitialState();

    _this.domino = function () {
      if (!_this.state.animatedNotifications.length) {
        return;
      }

      _this.popNotification();

      _this.dominoTimer.init(function () {
        _this.domino();
      }, COLLAPSE_INTERVAL);
    };

    _this.cancelTimers = function () {
      _this.cleanUpTimer.cancel();

      _this.dominoTimer.cancel();
    };

    _this.setupTimers = function () {
      _this.cancelTimers();

      _this.cleanUpTimer.init(function () {
        _this.domino();
      }, TIMEOUT);
    };

    _this.generateNextKey = function () {
      return "rsn/notification@" + ++_this.countNotifications;
    };

    _this.popNotification = function () {
      var updateState = function updateState(prevState) {
        var animatedNotifications = prevState.animatedNotifications;
        animatedNotifications.pop();
        return {
          animatedNotifications: animatedNotifications.clone()
        };
      };

      _this.setState(updateState);
    };

    _this.showNotification = function (notification) {
      _this.setupTimers();

      var updateState = function updateState(prevState) {
        var animatedNotifications = prevState.animatedNotifications;
        animatedNotifications.add(_assign(_assign({}, notification), {
          index: 0,
          key: _this.generateNextKey()
        }));
        return {
          animatedNotifications: animatedNotifications.clone()
        };
      };

      _this.setState(updateState);
    };

    _this.turnOverviewingOn = function () {
      _this.cancelTimers();

      _this.setState({
        isOverviewing: true
      });
    };

    _this.turnOverviewingOff = function () {
      _this.setupTimers();

      _this.setState({
        isOverviewing: false
      });
    };

    _this.onOverviewToogle = function (isOverviewing) {
      if (isOverviewing) {
        _this.turnOverviewingOn();
      } else {
        _this.turnOverviewingOff();
      }
    };

    return _this;
  }

  NotificationManager.prototype.getInitialState = function () {
    return {
      isOverviewing: false,
      animatedNotifications: new InverseIndexedQueue(MAX_NOTIFICATIONS + 1)
    };
  };

  NotificationManager.prototype.componentWillUnmount = function () {
    this.cancelTimers();
  };

  NotificationManager.prototype.render = function () {
    return React.createElement("div", {
      className: "ztc-container"
    }, React.createElement(AnimatedContainer, {
      offset: this.props.offset,
      height: this.props.height,
      component: this.props.component,
      isOverviewing: this.state.isOverviewing,
      notifications: this.state.animatedNotifications.items,
      onOverviewToogle: this.onOverviewToogle
    }));
  };

  return NotificationManager;
}(React.PureComponent);

var Notifier =
/** @class */
function () {
  function Notifier() {}

  Notifier.prototype.notify = function (notification) {
    if (this.managerRef.current) {
      this.managerRef.current.showNotification(notification);
    }
  };

  Notifier.prototype.init = function () {
    if (this.containerEl) {
      return;
    }

    this.containerEl = document.createElement('div');
    document.body.appendChild(this.containerEl);
    this.managerRef = React.createRef();
  };

  Notifier.prototype.portal = function (options) {
    this.init();
    return ReactDOM.createPortal(React.createElement(NotificationManager, _assign({}, options, {
      ref: this.managerRef
    })), this.containerEl);
  };

  Notifier.prototype.error = function (message) {
    this.notify({
      message: message,
      kind: 'error'
    });
  };

  Notifier.prototype.success = function (message) {
    this.notify({
      message: message,
      kind: 'success'
    });
  };

  Notifier.prototype.warning = function (message) {
    this.notify({
      message: message,
      kind: 'warning'
    });
  };

  Notifier.prototype.info = function (message) {
    this.notify({
      message: message,
      kind: 'info'
    });
  };

  Notifier.defaultConfig = config;
  return Notifier;
}();

var notifier = new Notifier();
var NotifierPortal = React.memo(function (props) {
  // For SSR support ¯\_(ツ)_/¯
  if (typeof window === 'undefined') {
    return null;
  }

  return notifier.portal(_assign(_assign({}, config), props));
});
export default notifier;
export { DarkModeContext, Notification, Notifier, NotifierPortal };